/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2TasksHomeIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2TasksHomeIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2TasksHomeIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#0E5814"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2TasksHomeIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-1oTeSg': alignSelf,'--mt-2-1oTeSg': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1oTeSg': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1oTeSg': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1oTeSg': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1oTeSg': opacity,'--w-10-1oTeSg': typeof width === 'number' ? `${width}px` : width,'--h-11-1oTeSg': typeof height === 'number' ? `${height}px` : height,'--f-12-1oTeSg': fill,'--a-7-1oTeSg': isAnimated ? animation : "none",'--sd-8-1oTeSg': isAnimated ? strokeDashoffset : 0,'--sd-9-1oTeSg': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2TasksHomeIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M9 .429a.967.967 0 00-.487.13 1.729 1.729 0 00-.16.103c-.087.061-.186.14-.287.223-.207.17-.477.406-.785.683-.619.555-1.423 1.3-2.243 2.07a495.282 495.282 0 00-3.828 3.64c-.281.27-.49.573-.62.926A2.865 2.865 0 00.428 9.21v6.265c0 1.148.948 2.096 2.096 2.096h12.951a2.108 2.108 0 002.096-2.096V9.21c0-.38-.056-.75-.213-1.11a2.837 2.837 0 00-.66-.912 484.77 484.77 0 00-3.878-3.683 135.763 135.763 0 00-2.154-1.986 24.574 24.574 0 00-.75-.65 4.904 4.904 0 00-.277-.214 1.678 1.678 0 00-.158-.1A.966.966 0 009 .429zM3.44 15.735h11.12a5.857 5.857 0 00-11.12 0zM9 10.416a2.64 2.64 0 100-5.28 2.64 2.64 0 000 5.28z"
 style={{'--f-12-1oTeSg': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}